import analytics from '../cdpAnalytics'

export function showLiveViewModal() {
  window.location.hash = 'now-playing'
  let testGroup = null
  const setLimitTestGroup = JSON.parse(localStorage.getItem('meta.setGroup'))
  if (setLimitTestGroup) {
    testGroup = setLimitTestGroup
  }
  // eslint-disable-next-line camelcase
  analytics.page('Now Playing', { test_group_set_limit: testGroup })
}
